import { Box, Button, Stack } from '@atgfr8/atg-ui-tailwind';
import { CategoryT } from '@common/types';
import { PlusIcon, ChevronDownIcon, ChevronUpIcon } from '@atgfr8/icons';
import { createSignal, For, Show } from 'solid-js';

import { CommonFileUploadFiles } from './CommonFileUpload';
import { FileCard } from './FileCard';

type PropsT = {
  files: CommonFileUploadFiles[];
  category: CategoryT;
  onDelete: (file: CommonFileUploadFiles) => void;
  onUpload: () => void;
};

export const FileCategory = (props: PropsT) => {
  const [isOpen, setIsOpen] = createSignal(true);
  const [buttonRef, setButtonRef] = createSignal<HTMLButtonElement>();

  const GetRelevantFiles = () => {
    return props.files
      .filter((file) =>
        file.taggedCategoryKeys?.includes(props.category.categoryKey),
      )
      .sort((a, b) => {
        const dateA = a.dateAdded != null ? new Date(a.dateAdded).getTime() : 0;
        const dateB = b.dateAdded != null ? new Date(b.dateAdded).getTime() : 0;

        return dateB - dateA;
      });
  };

  return (
    <Box mb="10px">
      <Box
        backgroundColor="#d2e2ed"
        padding="4px 8px"
        style={{
          'border-radius': isOpen() ? undefined : '5px',
          'border-top-left-radius': '5px',
          'border-top-right-radius': '5px',
          cursor: 'pointer',
        }}
        onClick={(e) => {
          if (
            // @ts-expect-error It doesn't matter if the button ref is undefined.
            e.target.isEqualNode(buttonRef()) ||
            Boolean(buttonRef()?.contains(e.target))
          ) {
            return;
          }

          setIsOpen((prev) => !prev);
        }}
      >
        <Stack direction="row">
          <Box
            fontSize="16px"
            fontWeight={400}
            style={{
              'line-height': '28px',
              'user-select': 'none',
              flex: 1,
            }}
          >
            {props.category.title}
          </Box>
          <Box>
            <Button
              ref={setButtonRef}
              variant="outlined"
              size="sm"
              startIcon={<PlusIcon size={20} />}
              class="bg-white! hover:bg-[#f9f9f9]!"
              onClick={props.onUpload}
              dataTestId={`file-category-add-file-${props.category.categoryKey}`}
            >
              Add File
            </Button>
          </Box>
          <Box class="pl-[10px]">
            {isOpen() ? <ChevronUpIcon /> : <ChevronDownIcon />}
          </Box>
        </Stack>
      </Box>
      <Show when={isOpen()}>
        <Box
          backgroundColor="#fff"
          style={{
            'border-bottom-left-radius': '5px',
            'border-bottom-right-radius': '5px',
          }}
        >
          <For each={GetRelevantFiles()}>
            {(file) => {
              return (
                <FileCard
                  file={file}
                  onDelete={() => {
                    props.onDelete(file);
                  }}
                />
              );
            }}
          </For>
        </Box>
      </Show>
    </Box>
  );
};
